import React, { useId } from 'react';

// Paper Crane mark — brand guide: design/logos/paper-crane/brand-guide.html
// Facets are separated by cuts (masked strokes), so the gaps stay transparent
// over photos and the mark works in a single ink when accentColor is null.

const GAP = 3.5;

// [points, isBackWing] — drawn back to front on a 100×100 grid
const FACETS = [
  ['50,70 70,20 64,70', true],    // back wing (accent)
  ['46,70 26,14 62,68', false],   // front wing
  ['2,50 34,72 22,76', false],    // tail
  ['20,74 48,70 68,74 50,86', false], // body
  ['64,72 88,32 93,35 72,78', false], // neck
  ['88,32 99,42 93,35', false],   // head
];

const facetMask = (id, show) => (
  <mask id={id} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
    <rect width="100" height="100" fill="black" />
    {FACETS.map(([points, isBack]) => (
      <polygon
        key={points}
        points={points}
        fill={show(isBack) ? 'white' : 'black'}
        stroke="black"
        strokeWidth={GAP}
        strokeLinejoin="round"
      />
    ))}
  </mask>
);

const LogoPaperCrane = ({ size = 50, color = '#1a1a1a', accentColor = null, title = 'Antoine Pierson' }) => {
  const uid = useId().replace(/:/g, '');
  const inkId = `crane-ink-${uid}`;
  const accentId = `crane-accent-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <defs>
        {facetMask(inkId, (isBack) => !accentColor || !isBack)}
        {accentColor && facetMask(accentId, (isBack) => isBack)}
      </defs>
      <rect width="100" height="100" fill={color} mask={`url(#${inkId})`} />
      {accentColor && <rect width="100" height="100" fill={accentColor} mask={`url(#${accentId})`} />}
    </svg>
  );
};

export default LogoPaperCrane;
